import { FC } from 'react';
import { CustomerTaskCardBase } from './CustomerTaskCardBase';

interface SuccessCardProps {
  type: string;
  message: string | undefined;
  headerText: string;
  date: string;
  title: string;
}

export const SuccessCard: FC<SuccessCardProps> = ({ type, message, headerText, date, title }: SuccessCardProps) => {
  return (
    <CustomerTaskCardBase borderColor="green" headerText={headerText} headerColor="green" icon="success">
      <div className="text-sm font-bold text-gray-700">{type}</div>
      <div className="my-1 font-bold">{title}</div>
      <div className="text-base font-semibold w-full truncate">{message}</div>
      <div className="text-sm text-gray-700">{date}</div>
    </CustomerTaskCardBase>
  );
};
